package com.gsb.vyapar.bhagya.presentation.dialog.uistate

import com.gsb.vyapar.bhagya.presentation.dialog.Dialogs
import com.gsb.vyapar.bhagya.presentation.dialog.Dialogs.Loading

data class DialogUiState(
    val title: String = "",
    val message: String = "",
    val dialogType: Dialogs = Loading,
    val onCloseClick: () -> Unit = {},
    val onOKClick: () -> Unit = {},
    val onCancelClick: () -> Unit = {},
    val otpLogin: String = "Login with OTP",
    val passwordLogin: String = "Login with Password",
    val onOtpLoginClick: () -> Unit = {},
    val onPasswordLoginClick: () -> Unit = {},
    val buttonString: String = "OK",
    val camera: String = "Camera",
    val gallery: String = "Gallery",
    val onCameraClick: () -> Unit = {},
    val onGalleryClick: () -> Unit = {},
    val deviceLocation: String = "Use Device Location",
    val enterPincode: String = "Enter Pincode",
    val onSavePincode: (pincode: String) -> Unit = {},
    val onDeviceLocationClick: () -> Unit = {},
    val onEnterPincodeClick: () -> Unit = {},
)